import en from './en/translation.json'
import ch from './ch/translation.json'
import hi from './hi/translation.json'
import es from './es/translation.json'

const messages = {
  en,
  ch,
  hi,
  es
}

export default messages;